import { render, staticRenderFns } from "./Movement-list.vue?vue&type=template&id=56ba8d53&"
import script from "./Movement-list.vue?vue&type=script&lang=js&"
export * from "./Movement-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports